import Vue from "vue";

Vue.directive("infinite", {
  // When the bound element is inserted into the DOM...
  bind(el, binding, vnode) {
    const offset = 30;
    // Detect when scrolled to bottom.
    el.addEventListener("scroll", function() {
      const scrollTop = el.scrollTop;
      if (scrollTop + el.clientHeight >= el.scrollHeight - offset) {
        // prevent any more scroling until promise has resolved

        const n =
          document.querySelectorAll(binding.value.nestedEl).length -
          binding.value.numPerRow * 2;
        const promise = new Promise((resolve, reject) => {
          resolve(binding.value.fn());
        });
        wrapPromise(promise).then(() => {
          Vue.nextTick().then(() => {
            const nestedSelector = document.querySelector(
              `${binding.value.nestedEl}:nth-of-type(${n})`
            );
            if (nestedSelector) {
              nestedSelector.scrollIntoView();
            }
          });
        });
      }
    });
  }
});

function wrapPromise(promise) {
  promise.isPending = true;
  return promise.then(() => {
    return (promise.isPending = false);
  });
}
